(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ne-product-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function buildLegacy(section) {
    const source = section.querySelector('[data-faq-legacy-source] .metafield-rich_text_field');
    const list = section.querySelector('[data-faq-legacy-list]');
    if (!source || !list || list.childElementCount) return;

    const paragraphs = Array.from(source.children).filter((node) => node.tagName === 'P');
    for (let index = 0; index < paragraphs.length; index += 2) {
      const questionNode = paragraphs[index];
      const answerNode = paragraphs[index + 1];
      if (!questionNode) continue;

      const question = questionNode.textContent.trim();
      const answer = answerNode ? answerNode.innerHTML.trim() : '';
      if (!question) continue;

      const item = document.createElement('details');
      item.className = 'ne-product-faq__item';

      const summary = document.createElement('summary');
      summary.className = 'ne-product-faq__question';

      const label = document.createElement('span');
      label.textContent = question;

      const plus = document.createElement('span');
      plus.className = 'ne-product-faq__plus';
      plus.setAttribute('aria-hidden', 'true');

      const body = document.createElement('div');
      body.className = 'ne-product-faq__answer';
      body.innerHTML = answer;

      summary.appendChild(label);
      summary.appendChild(plus);
      item.appendChild(summary);
      item.appendChild(body);
      list.appendChild(item);
    }
  }

  function collapse(section) {
    const list = section.querySelector('.ne-product-faq__list');
    if (!list || list.dataset.neCollapsed) return;

    const items = Array.from(list.querySelectorAll('.ne-product-faq__item'));
    const visible = parseInt(section.dataset.visibleCount || '6', 10) || 6;
    if (items.length <= visible) return;

    list.dataset.neCollapsed = 'true';
    const extras = items.slice(visible);
    extras.forEach((item) => { item.hidden = true; });

    const moreLabel = 'See all questions (' + items.length + ')';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ne-product-faq__toggle';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = moreLabel;

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      extras.forEach((item) => { item.hidden = expanded; });
      button.setAttribute('aria-expanded', String(!expanded));
      button.textContent = expanded ? moreLabel : 'Show fewer questions';
      if (expanded) {
        list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    list.insertAdjacentElement('afterend', button);
  }

  function init(root) {
    root.querySelectorAll('.ne-product-faq').forEach((section) => {
      buildLegacy(section);
      collapse(section);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
